import Vue from 'vue';
import Map from './map';
export default (() => {
  let list = [Map]
  //循环注册组件
  list.forEach(ele => {
    Vue.component(`avue-echart-${ele.name}-xhn`,ele)
  })
})()